<template>
    <el-drawer
        title="入住信息"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <template v-if="data">
				<div class="group">
					<div class="page-group-title"><span>入住信息</span></div>
				    <table class="info-table MT20" width="100%">
				        <tr>
				            <th>酒店ID</th>
				            <td>{{data.hotelId}}</td>
				            <th>酒店名称</th>
				            <td>{{data.hotelName}}</td>
				        </tr>
				        <tr>
				            <th>房间ID</th>
				            <td>{{data.roomId}}</td>
				            <th>房间名称</th>
				            <td>{{data.roomName}}</td>
				        </tr>
				        <tr>
				            <th>房间数</th>
				            <td>{{data.roomNumber}}</td>
				            <th>入住人</th>
				            <td>{{data.occupant}}</td>
				        </tr>
				        <tr>
				            <th>联系人</th>
				            <td>{{data.contacterName}}</td>
				            <th>联系电话</th>
				            <td>{{data.contacterMobile}}</td>
				        </tr>
				    </table>
				</div>
			</template>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>

export default {
    data() {
        return {
            drawerShow: false,
			orderId:'',
			data:null
            
        }
    },
    methods: {
        close() {            
            this.data = null;
            this.drawerShow = false;
           
        },
        show(id) {           
            this.orderId = id;
            this.getDataList();
            this.drawerShow = true;
        },
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/hotelOrder/checkInInformation",
                method: "POST",
                params: {
					orderId:this.orderId
				},
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
       
        
    }
}
</script>

<style lang="scss" scoped>
</style>